export default __webpack_public_path__ + "static/media/centerBr.89ecc9f7.png";